import axios from 'axios'
import SortService from '@/services/sort.service'

export default {
    namespaced: true,
    state: {
        voicemails: [],
        customerVM: [],
    },
    mutations: {
        SET_VOICEMAILS(state, voicemails) {
            state.voicemails = voicemails;
        },
        ADD_NEW_VOICEMAIL(state, voicemail) {
            state.voicemails.push(voicemail);
        },
        SET_CUSTOMERS_VOICE_MAILS(state, vm) {
            state.customerVM = vm;
        },
        DELETE_VOICEMAIL(state, id) {
            const index = state.voicemails.findIndex(voicemail => voicemail.id === id);
            state.voicemails.splice(index, 1);
        },
    },
    getters: {
        voicemails: state => state.voicemails,
        customerVM: state => state.customerVM,
        notListenedCustomerVM: state => state.notListenedCustomerVM,
    },
    actions: {
        getVoiceMails({ commit }, user_id) {
            axios.get("/voicemail/" + user_id).then((res) => {
                commit("SET_VOICEMAILS", res.data.voicemails);
            }).catch((err) => {
                console.log(err);
            });
        },
        getCustomersVoiceMails({ commit }, lead_id) {
            axios.get("/voicemail/customers/" + lead_id).then((res) => {
                commit("SET_CUSTOMERS_VOICE_MAILS", SortService.formatCreatedAtInObject(res.data.vm))
            }).catch((err) => {
                console.log(err);
            });
        },
    },
}
